import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  /* background: var(--document-background); */
  padding: 4px;
  margin-top: 10px;

  svg.thumb {
    width: 18px;
    height: 18px;
    padding: 2px;

    path {
      fill: var(--grey-0);
    }
  }
`;
